module.exports = __webpack_public_path__ + "static/media/YM44_4.31653533.jpg";